<template>
  <label class="w-checkbox checkbox-field">
    <input
      @input="returnValue"
      type="checkbox"
      class="w-checkbox-input"
      v-model="isChecked"
    />
    <span class="w-form-label">
      Ik geef toestemming om deze persoonsgegevens te verwerken.
    </span>
  </label>
</template>

<script>
export default {
  props: ["initial_value"],
  data() {
    return {
      isChecked: false,
    }
  },
  created() {
    this.isChecked = this.initial_value
  },
  methods: {
    returnValue() {
      this.$emit("isChecked", !this.isChecked)
    },
  },
}
</script>
